export default __webpack_public_path__ + "static/media/sd-banner-4.49a8b4e8.jpg";